import { BLACKOUT_RETURN_BEAT, BLACKOUT_RETURN_CUES, BLACKOUT_RETURN_FLAGS } from '@/story/act2/blackoutReturn';
import { CULL_RETURN_EXIT_Z } from '@/world/cullCorridor';
import { fadeStoryPart } from '@/game/beats/fadeStoryPart';
import type { BeatPartModuleDefinition } from '@/game/beatPartModule';

/**
 * Beat 8 part 1: the cull corridor walked the other way, and nothing else.
 *
 * Deliberately not a `CullDirector` variant: beat 5's machine, sheeting, bin
 * and camera are what the return says are absent, and a director that shared
 * them would leave a replay mechanism in the room that a later cue could wake.
 * Until session 83 this was `BlackoutReturnDirector`, a copy of
 * `BeatFadeDirector` with the cue ids baked in, wired by a branch in `main.ts`.
 */
export const BLACKOUT_RETURN_PART_MODULE: BeatPartModuleDefinition = {
  beat: 8,
  part: 1,
  room: 'cull',
  create: fadeStoryPart({
    beat: BLACKOUT_RETURN_BEAT,
    cues: BLACKOUT_RETURN_CUES,
    fixedStep({ player, raiseFlag }): void {
      if (player.z <= CULL_RETURN_EXIT_Z) raiseFlag(BLACKOUT_RETURN_FLAGS.atExit);
    },
  }),
};
